<template lang="html">
  <div>
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.appManagement')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flex-row second-tip">
      <div class="title"></div>
      <div class="flex-row search-container">
        <el-input class="app-search" :placeholder="$t('message.enterApp')" v-model="appManagementSearch"
          @keyup.enter.native="searchApplist" clearable>
        </el-input>
        <el-button class="search-btn" icon="el-icon-search" @click="searchApplist"></el-button>
        <div v-if="queryFlag">
          <router-link :to="{path:'/appEdit/',query:{id:'newApp'}}">
            <el-button type="primary" plain class="verifone-btn" icon="el-icon-plus">{{$t('message.add')}}</el-button>
          </router-link>
        </div>
        <el-button v-else disabled type="primary" plain class="verifone-btn" icon="el-icon-plus">{{$t('message.add')}}</el-button>
      </div>
    </div>

    <div class="appManagement-table">
      <div class="appManagement-table-main verifone-panel btn-table">
        <template>
          <el-table :data="tableData" style="width: 100%" tooltip-effect="dark">
            <!-- Logo -->
            <el-table-column align="center" prop="logo" :label="$t('message.app')" width="60">
              <template slot-scope="scope">
                <img :src="scope.row.logo"  min-width="36" height="36" />
              </template>
            </el-table-column>

            <!-- App Name -->
            <el-table-column prop="name" min-width="200" show-overflow-tooltip></el-table-column>

            <!-- Version -->
            <el-table-column :label="$t('message.version')" min-width="160" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-select v-model="scope.row.selectVersion" @change="versionSelectChange(scope)">
                  <el-option v-for="item in scope.row.versionList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>

            <!-- 开发商 -->
            <el-table-column prop="company" :label="$t('message.developer')" min-width="120" show-overflow-tooltip />

            <!--<el-table-column prop="utime" :label="$t('message.date')" width="120" show-overflow-tooltip />-->

            <!-- 软件大小 -->
            <el-table-column prop="size" :label="$t('message.size')" min-width="80" />

            <!-- App 上次时间 -->
            <el-table-column prop="apkUploadTime" min-width="150" :label="$t('message.appUploadTime')"/>

            <!-- 操作 -->
            <el-table-column :label="$t('message.operation')" min-width="220" align="center">
              <template slot-scope="scope">
                <router-link :to="{path:'/appEdit/',query:{id:scope.row.id,version:scope.row.version,name:scope.row.name}}">
                  <el-button v-if="queryFlag" class="op-btn verifone-btn" type="success" plain icon="el-icon-edit">{{$t('message.edit')}}</el-button>
                  <el-button v-else disabled class="op-btn verifone-btn" type="success" plain icon="el-icon-edit">{{$t('message.edit')}}</el-button>
                </router-link>
                <el-button v-if="queryFlag" type="danger" plain icon="el-icon-close" class="op-btn verifone-btn" @click="showDeleteDialog(scope.row)">{{$t('message.delete')}}</el-button>
                <el-button v-else disabled type="danger" plain icon="el-icon-close" class="op-btn verifone-btn">{{$t('message.delete')}}</el-button>
              </template>
            </el-table-column>

          </el-table>
        </template>

        <div class="pagination-main">
          <el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :current-page="pageNum"
            :page-count="pageCount">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- ---------------------------删除APP提示框 start--------------------------- -->
    <el-dialog title="" :visible.sync="deleteTipVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
      <div class="warn-container flex-row">
        <img class="warn-icon" alt="" src="static/img/alertWarn.png">
        <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
      </div>
      <div class="dialog-body">
        <span>{{$t('message.deleteAppTop')}}</span>
        <span>{{taskName}}</span>
        <span>{{$t('message.deleteAppFoot')}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" plain @click="deleteTipVisible = false;deleteAppId=''">{{$t('message.no')}}</el-button>
        <el-button class="verifone-btn" type="primary" @click="deleteApp">{{$t('message.yes')}}</el-button>
      </span>
    </el-dialog>
    <!-- ---------------------------删除APP提示框 end--------------------------- -->

    <!-- ---------------------------强制删除APP提示框 start--------------------------- -->
    <el-dialog title="" :visible.sync="forceDeleteVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
      <div class="warn-container flex-row">
        <img class="warn-icon" alt="" src="static/img/alertWarn.png">
        <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
      </div>
      <div class="dialog-body">
        <span>{{$t('message.forceDelete')}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" plain @click="forceDeleteVisible = false">{{$t('message.no')}}</el-button>
        <el-button class="verifone-btn" type="primary" @click="forceDelete">{{$t('message.yes')}}</el-button>
      </span>
    </el-dialog>
    <!-- ---------------------------强制删除APP提示框 end--------------------------- -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageNum: 1,
        pageCount: 1,
        deleteAppId: '',
        appManagementSearch: '',
        deleteTipVisible: false,
        forceDeleteVisible: false,
        researchType: 0, //0 为查询分页查询APP 1搜索APP
        tableData: [], // App集合（仅最新）
        allVersionData: [], // APP集合（新版与旧版）
        queryFlag: false,
        taskName: '',
        deleteSuccess: this.$t('message.deleteSuccess')
      }
    },
    mounted() {
      this.quryAppList();
      this.setQuery();
    },
    methods: {
      setQuery() {
        let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
        this.queryFlag = !roleArr.includes(31);
      },
      handleCurrentChange(val) {
        console.log("val" + val);
        this.pageNum = val;
        if (this.researchType == 0) {
          this.quryAppList();
        } else if (this.researchType == 1) {
          this.searchApplist();
        }
        console.log('当前页: ' + val);
      },

      quryAppList() {
        const that = this;
        let obj = {
          pageNum: this.pageNum
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/app/page',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            that.researchType = 0;
            //this.$refs.codeImg.src = response.data.image;
            that.pageCount = response.data.totalPage;
            that.tableData = response.data.appList;
            that.allVersionData = response.data.allAppList;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      searchApplist() {
        const that = this;
        let obj = {
          info: this.appManagementSearch,
          pageNum: this.pageNum
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/app/search',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            that.researchType = 1;
            that.pageCount = response.data.totalPage;
            that.tableData = response.data.appList;
            that.allVersionData = response.data.allAppList;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      showDeleteDialog(row) {
        this.deleteTipVisible = true;
        this.deleteAppId = row.id;
        this.taskName = row.name + '_' + row.version;
      },
      forceDelete() {
        const that = this;
        console.log("this.deleteAppId" + this.deleteAppId);
        let obj = {
          id: this.deleteAppId
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/app/forcedelete',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            that.deleteAppId = '';
            that.forceDeleteVisible = false;
            that.$message({
              type: "success",
              message: this.deleteSuccess,
              duration: '3000',
            });
            if (that.researchType == 0) {
              that.quryAppList();
            } else if (that.researchType == 1) {
              that.searchApplist();
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      deleteApp() {
        const that = this;
        let obj = {
          id: this.deleteAppId
        };

        this.$axios({
          method: 'post',
          url: '/marketplace/app/delete',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          },
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            if (response.data.inRunningTaskFlag == 1) {
              that.deleteTipVisible = false;
              that.forceDeleteVisible = true;
            } else {
              that.deleteTipVisible = false;
              that.deleteAppId = '';
              that.$message({
                type: "success",
                message: this.deleteSuccess,
                duration: '3000',
              });
              if (that.researchType == 0) {
                that.quryAppList();
              } else if (that.researchType == 1) {
                that.searchApplist();
              }
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      // 版本下拉框 选中值发生变化时触发
      versionSelectChange(scope){
        var rowIndex = scope.$index;

        var row = scope.row;
        var versionList = row.versionList;
        var packageName = row.packageName;
        var selectVersion = row.selectVersion;

        var newRow;
        for(var i=0,len=this.allVersionData.length; i<len; i++){
          var data = this.allVersionData[i];
          if(data.packageName == packageName && data.version == selectVersion){
            newRow = data;
            break;
          }
        }

        newRow.selectVersion = selectVersion;
        newRow.versionList = versionList;

        this.tableData.splice(rowIndex,1,newRow);
      }

    }
  }
</script>

<style lang="css" scoped="scope">
  .appManagement-container {
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    width: 100%;
  }

  .appManagement-table {
    width: 100%;
  }

  .appManagement-table-main {
    padding: 20px;
    background-color: #fff;
  }

  .pagination-main {
    padding: 30px 0 10px;
    background: #fff;
    width: 100%;
  }

  .appManagement-search .el-input__inner {
    border-radius: 20px;
  }

  .reachInput {
    width: 300px;
    margin-right: 10px;
  }

  .app-search {
    width: 400px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/AppManagement.vue